import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getstaffs: option => request('v1/sysstaff/getstaffs', option, true, false), // 查询人员列表
  getstaff: option => request('v1/sysstaff/getstaff', option, true, false), // 查询人员
  addstaff: option => request('v1/sysstaff/addstaff', option, true, false), // 新增人员
  updatestaff: option => request('v1/sysstaff/updatestaff', option, true, false), // 修改人员
  updateme: option => request('v1/sysstaff/updateme', option, true, false), // 修改人员
  deletestaff: option => request('v1/sysstaff/deletestaff' + querystring(option), {}, true, false), //  删除人员
  getorgportalmenutree: option => request('v1/sysstaff/getorgportalmenutree' + querystring(option), {}, true, false) //  删除人员
}
